import { Button, ButtonGroup, Heading, Modal, Paragraph, TextButton } from '@zillow/constellation-10';

import { useHistory } from 'react-router';
import { useIsFetching, useIsMutating } from '@zg-rentals/react-query5';
import LeaseExtension from '../models/LeaseExtension';
import type { LeaseActionProps } from '../models/Types';
import { CANCEL } from '../constants/stringConstants';
import { useArchiveLeaseMutation } from '../utils/queries';
import { LeaseArtifactType } from '@zg-rentals/ts-leasing-client';
import { useLeasingUrlParams } from '../hooks';

export default function RequestLeaseExtensionSignatureModal({ terminateActiveAction, lease }: LeaseActionProps) {
  const isFetching = useIsFetching() > 0;
  const isMutating = useIsMutating() > 0;
  const history = useHistory();
  const archiveLeaseMutation = useArchiveLeaseMutation();

  const { renewalId } = useLeasingUrlParams();

  const latestExtension = lease?.latestExtension ?? null;
  const extensionId = renewalId || latestExtension?.id || '';

  async function onArchiveLease() {
    await archiveLeaseMutation.mutateAsync({
      postData: {
        leaseArtifactId: extensionId as unknown as number,
        leaseArtifactType: LeaseArtifactType.LEASE_EXTENSION_RENEWAL,
      },
    });
    await terminateActiveAction();
    history.push(LeaseExtension.getDashboardPath());
  }

  return (
    <Modal
      size={{ base: 'fullScreen', md: 'sm' }}
      open
      onOpenChange={(open) => {
        if (!open) {
          terminateActiveAction();
        }
      }}
      header={<Heading level={1}>Delete your lease renewal draft?</Heading>}
      body={<Paragraph>You won’t be able to view or restore the draft if you delete it.</Paragraph>}
      footer={
        <ButtonGroup aria-label="delete draft">
          <TextButton tone="brand" onClick={terminateActiveAction} disabled={isFetching || isMutating}>
            {CANCEL}
          </TextButton>
          <Button
            tone="brand"
            emphasis="filled"
            onClick={onArchiveLease}
            loading={isFetching || isMutating}
            disabled={isFetching || isMutating}
          >
            Yes
          </Button>
        </ButtonGroup>
      }
    />
  );
}
